import type {AxiosError} from 'axios';
import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	resendLoginCode,
	type ResendLoginCodeErrorResponse,
	type ResendLoginCodeRequest,
	type ResendLoginCodeResponse,
} from '../../http';

export function useResendLoginCode(
	options?: UseMutationOptions<ResendLoginCodeResponse, AxiosError<ResendLoginCodeErrorResponse>, ResendLoginCodeRequest>,
): UseMutationResult<ResendLoginCodeResponse, AxiosError<ResendLoginCodeErrorResponse>, ResendLoginCodeRequest> {
	return useMutation<ResendLoginCodeResponse, AxiosError<ResendLoginCodeErrorResponse>, ResendLoginCodeRequest>(
		(request) => resendLoginCode(request).then(({data}) => data),
		options,
	);
}
